var $ = require('jquery');
window.jQuery = $;
window.$ = $;


// WEBPACK FOOTER //
// ./src/plugins/jquery.js